// extracted by mini-css-extract-plugin
module.exports = {"university-partenrs-wrapper":"UniversityPartners_university-partenrs-wrapper__3tHgV"};